import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { IGroupImage } from 'app/library/group/interfaces/group-avatar.interface';
import { IEnvironment } from 'app/projects/core/src/lib/interfaces/environment.interface';
import { FileCommand } from 'app/projects/core/src/lib/models/file.command';
import { MAXBRAIN_ENVIRONMENT } from 'app/projects/core/src/lib/services/environment.token';
import { EntityService } from 'app/projects/entity/src/lib/services/entity.service';
import { NotifyType } from 'app/projects/shared/src/lib/enums/notify-type.enum';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IGroupQuery } from '../interfaces/group.query.interface';
import { Group } from '../models/group';
import { GroupAvatar } from '../models/group-avatar';
import { GroupCommand } from '../models/group.command.model';

@Injectable()
export class GroupApiService extends EntityService<IGroupQuery, GroupCommand> {
    constructor(http: HttpClient, @Inject(MAXBRAIN_ENVIRONMENT) environment: IEnvironment) {
        super(http, environment.apiUrl, 'general/groups');
    }

    getAll(): Observable<Group[]> {
        return this.http.get<IGroupQuery[]>(`${this.apiUrl}/${this.entities}`).pipe(map((queries) => queries.map((query) => new Group(query))));
    }

    create(entity: Group): Observable<Group> {
        const data = new GroupCommand(entity);

        return this.http.post<IGroupQuery>(`${this.apiUrl}/${this.entities}`, data).pipe(map((query) => new Group(query)));
    }

    read(id: string): Observable<Group> {
        return this.http.get<IGroupQuery>(`${this.apiUrl}/${this.entities}/${id}`).pipe(map((query) => new Group(query)));
    }

    update(entity: Group): Observable<Group> {
        const data = new GroupCommand(entity);

        return this.http.patch<IGroupQuery>(`${this.apiUrl}/${this.entities}/${entity.id}`, data).pipe(map((query) => new Group(query)));
    }

    delete(id: string, notify: NotifyType): Observable<any> {
        return this.http.delete(`${this.apiUrl}/${this.entities}/${id}?notify=${notify}`);
    }

    leaveGroup(id: string): Observable<any> {
        return this.http.delete(`${this.apiUrl}/groups/${id}/leave-group`);
    }

    uploadImage(file: File): Observable<GroupAvatar> {
        const data = new FileCommand('file', new File([file], '', { type: file.type }), file.name).formData;

        return this.http.post<IGroupImage>(`${this.apiUrl}/attachments`, data).pipe(map((query) => new GroupAvatar(query)));
    }
}
